import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "md:ml-5 ml-4 mb-auto md:my-auto mt-4 flex rounded-full mr-3 bg-primary bg-opacity-15",
  style: {"min-width":"2.5rem","max-width":"2.5rem","min-height":"2.5rem","max-height":"2.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"font-size":"28px !important"},
    class: "m-auto material-icons-outlined text-primary"
  }, "file_present")
], -1)
const _hoisted_2 = {
  key: 1,
  class: "opacity-0 group-hover:opacity-50 transition-opacity duration-100 ease absolute top-1/2 transform -translate-y-1/2 left-0 text-lg cursor-move drag-handle material-icons-outlined"
}
const _hoisted_3 = { class: "flex-col md:flex-row flex w-full py-4 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "my-auto overflow-hidden"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "flex flex-wrap ml-0.5" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm mr-2"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-muted",
  style: {"margin-right":"3px"}
}
const _hoisted_9 = { class: "z-10 mr-2 ml-auto flex items-center group-hover:opacity-100 transition-opacity duration-100 ease opacity-50" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " delete ", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinearProgress = _resolveComponent("LinearProgress")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_FileNodeDetail = _resolveComponent("FileNodeDetail")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      tabindex: "0",
      class: _normalizeClass(["relative flex rounded card-border group", {
				'card-hoverable hover-shadow-elevation hover:border-transparent': _ctx.isDraggable,
			}])
    }, [
      (_ctx.loadingFile || _ctx.loadingThumbnail)
        ? (_openBlock(), _createBlock(_component_LinearProgress, {
            key: 0,
            class: "absolute w-full top-0 left-0 rounded-t-sm"
          }))
        : _createCommentVNode("", true),
      _hoisted_1,
      (_ctx.isDraggable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " drag_indicator "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.node.file)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h4", {
                title: _ctx.node.file.name,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = true)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showDetails = true), ["enter"])),
                style: {"line-height":"0.95","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
                class: "mb-0.5 pr-1 cursor-pointer hover:text-primary hover:underline"
              }, _toDisplayString(_ctx.node.file.name), 41, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.node.creator)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.node.creator.full_name), 1))
                  : _createCommentVNode("", true),
                (_ctx.updatedOnDifferentDay)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("misc.updated_on")), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_Timestamp, {
                  "date-only": true,
                  class: "text-sm text-muted",
                  value: _ctx.node.modified
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                class: "mr-4",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deleteNode', _ctx.node))),
                variant: 'icon',
                outline: true,
                tooltip: _ctx.$t('misc.delete')
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["tooltip"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CopyToClipboard, {
            "icon-only": true,
            tooltip: _ctx.$t('exercise_solution.share'),
            value: _ctx.permalink
          }, null, 8, ["tooltip", "value"])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetails = true)),
        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.showDetails = true), ["enter"])),
        class: "bg-gray-200 lg:w-56 w-40 cursor-pointer flex rounded-tr-sm rounded-br-sm ml-auto relative overflow-hidden",
        style: {"min-height":"120px !important"}
      }, [
        (_ctx.thumbnailPresent)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "absolute top-0 w-11/12 left-1/2 transform -translate-x-1/2 pointer-events-none",
              src: _ctx.thumbnailSrc
            }, null, 8, _hoisted_11))
          : (!_ctx.loadingThumbnail)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                style: {"height":"50px !important","margin":"auto"},
                class: "pointer-events-none opacity-100",
                src: _ctx.defaultThumbnail
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true)
      ], 32)), [
        [_directive_wave, { initialOpacity: 0.25 }]
      ])
    ], 2),
    (_ctx.showDetails)
      ? (_openBlock(), _createBlock(_component_FileNodeDetail, {
          key: 0,
          onViewerClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetails = false)),
          node: _ctx.node
        }, null, 8, ["node"]))
      : _createCommentVNode("", true)
  ]))
}